





























































import Vue from 'vue';

// Services
import AnalyticService from '~/services/AnalyticService';

// Project components
import LayoutToggles from './LayoutToggles.vue';
import ListItemSkeleton from '~/components/skeletons/ListItemSkeleton.vue';
import PulsatingDot from '../components/miscellaneous/PulsatingDot.vue';
import Checkbox from '~/components/builders/Base/Checkbox.vue';
import { buildIDParam } from '~/utils/urlUtils';
import { OrganizationV2 } from '~/models';

interface ChatAvailability {
    id: string;
    count: number;
    organizationId: string;
}

type ExtendedOrganizationV2 = OrganizationV2 & { name: string; prioritized?: boolean };

export default Vue.extend({
    name: 'CompanyList',
    components: {
        PulsatingDot,
        LayoutToggles,
        ListItemSkeleton,
        Checkbox,
    },
    props: {
        label: {
            type: String,
            default: '',
        },
        withLayoutToggle: {
            type: Boolean,
            default: false,
        },
        isLoading: {
            type: Boolean,
            default: false,
        },
        data: {
            type: Array<ExtendedOrganizationV2>,
            default: () => [],
        },
        chatAvailability: {
            type: Array<ChatAvailability>,
            default: () => [],
        },
        resolveRoute: {
            type: Function,
            default: undefined,
        },
        chatFilterButton: {
            type: Boolean,
            default: false,
        },
        forceList: {
            type: Boolean,
            default: false,
        },
    },
    data: () => ({
        isList: false,
        chatFilterToggle: false,
    }),
    methods: {
        getData(): ExtendedOrganizationV2[] {
            if (this.chatFilterToggle) {
                return this.data.filter(item => {
                    return this.chatAvailability.filter(chatItem => chatItem.id === '' + item.id)
                        .length;
                });
            }
            return this.data;
        },
        getCompanyLink(id: number, companyName?: string): string {
            if (typeof this.resolveRoute !== 'undefined') return this.resolveRoute(id);
            else
                return this.$URLS.findcompanies.concat(
                    '/',
                    buildIDParam(id.toString(), companyName)
                );
        },
        hasChatUsersActive(id: number): boolean {
            return (
                this.chatAvailability.filter(
                    (item: ChatAvailability) => item.id === '' + id && item.count > 0
                ).length > 0
            );
        },
    },
    mounted() {
        AnalyticService.impressionEvent(AnalyticService.IMPRESSION_ACTIONS.COMPANYLIST_VIEW_ACTION);
    },
});
